export interface SessionRetakeDefinition {version:number;retake_scope:'none'|'part_a'|'part_b'|'both'}
export class SessionRetakeDefinitionError extends Error {}
export function applySessionRetakeDefinition<T extends object>(details:T,snapshot?:SessionRetakeDefinition|null):T & {session_retake_scope?:SessionRetakeDefinition['retake_scope']} {
  if(snapshot==null)return details;
  if(snapshot.version!==1 || !['none','part_a','part_b','both'].includes(snapshot.retake_scope))throw new SessionRetakeDefinitionError('Session retake definition is invalid or unsupported.');
  // The live grant/permission fields still describe eligibility for a future
  // attempt. Only current-attempt routing consumes session_retake_scope.
  return {...details,session_retake_scope:snapshot.retake_scope};
}
